export class Modal {

  constructor(data){
    this.$modal = $('#globalModal');

    // bind events
    this.$modal.on('click', '.js-close-modal', e => this.close(e));

    this.init(data);
  }

  /**
     * Fills the global modal with the provided data
     * @param data
     */
  init(data){
    // Modal invullen
    this.$modal.find('.js-modal-body').html('').append(
      $('<h2>', { html: data.title }),
      $('<p>', { html: (data.message ? data.message : '') })
    );
    this.$modal.find('.js-modal-footer').html('').append(
      $('<p>').append(
        $('<a>', {
          href: (data.btnSecondary.href ? data.btnSecondary.href : '#'),
          html: data.btnSecondary.value,
          class: 'btn btn-default btn-lg'
                    + (data.btnSecondary.class ? ' ' + data.btnSecondary.class : ''),
        }),
        $('<a>', {
          href: (data.btnPrimary.href ? data.btnPrimary.href : '#'),
          html: data.btnPrimary.value,
          class: 'btn btn-primary btn-lg'
                    + (data.btnPrimary.class ? ' ' + data.btnPrimary.class : ''),
        }))
    );

    this.$modal.modal('show');
  }

  close(e) {
    e.preventDefault();
    this.$modal.modal('hide');
  }

}
